import { Component, OnInit } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormGroup
  , FormControl
  , Validators
  , AbstractControl
  , ValidationErrors
  , FormBuilder
  , NgForm
  , FormGroupDirective
  , FormArray
} from '@angular/forms';
import { FormValidatorService } from '../../shared/form_Validation/form-validator.service';
import { ApiService } from '../../services/api.service';
import { CookieService } from 'ngx-cookie-service';
import { reCaptchaSiteKey } from 'src/app/config';
import { CustomValidator } from 'src/app/shared/services/custom-validator.service';
class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.invalid;
  }
}
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  errorMatcher = new CrossFieldErrorMatcher();
  resetPassword: FormGroup;
  verifyPassword: FormGroup;
  emailVerified = false;
  token: string;
  siteKey = reCaptchaSiteKey;
  googleToken: string;
  hide = true;
  hide2 = true;

  constructor(
    private route: ActivatedRoute
    , private router: Router
    , private Formvalidator: FormValidatorService
    , private formBuilder: FormBuilder
    , private _apiService: ApiService
    , private customValidator: CustomValidator
    , private cookieService: CookieService
    ) {
    this.FormInitResetPwd();
    this.verifyPassword = this.formBuilder.group({
      email: new FormControl('')
      , recaptcha: ['', Validators.required]
    });
  }
  FormInitResetPwd(){
    this.resetPassword = this.formBuilder.group({
      password: new FormControl('',  [Validators.required
        , this.customValidator.hasinitspace
        , Validators.minLength(8)
        ,  this.customValidator.hasUpperCase
        ,  this.customValidator.hasLowerCase
        ,  this.customValidator.hasNumber
        ,  this.customValidator.hasSymbol
        ,  this.customValidator.hasSpace]),
      confirmPassword: new FormControl('', [Validators.required]),
    }, { validator: this.passwordValidator });
  }
  passwordValidator(form: FormGroup) {
    const condition = form.get('confirmPassword').value !== form.get('password').value;
    return condition ? { passwordsDoNotMatch: true } : null;
  }
  handleSuccess($event) {
    this.googleToken = $event;
  }
  submitPassword() {
    if (this.token) {
      const data = {
        password: this.resetPassword.get('password').value
        , token: this.token
      };
      this._apiService.functionPOST('user/verifyResetPassword', data).subscribe((res) => {
        this.FormInitResetPwd();
         this.router.navigate(['/']);
        this.cookieService.deleteAll('/');
        this._apiService.openSnackBar(res['data'], 'Success');
      },
      err => {
        this.FormInitResetPwd();
        this._apiService.openSnackBar(err['error'], 'Error');
      });
    }
  }
  verifyEmail() {
    const data = {
      email: this.verifyPassword.get('email').value
      , captchaToken: this.googleToken
    };
    this._apiService.functionPOST('user/resetPassword', data).subscribe((res) => {
      this._apiService.openSnackBar(res['data'], 'Success');
      this.verifyPassword.reset();
    },
    err => {
      this.verifyPassword.reset();
      this._apiService.openSnackBar(err['error'], 'Success');
    });
  }

  get confirmError() {   
    return this.resetPassword.controls.confirmPassword.invalid
      && this.resetPassword.controls.confirmPassword.touched
      && !this.resetPassword.hasError('passwordsDoNotMatch');
  }
  ngOnInit() {
    this.route.queryParamMap.subscribe(paramsdata => {
      if (paramsdata['params'] && paramsdata['params']['token']) {
        this.token = paramsdata['params']['token'];
        this.emailVerified = true;
      }
    });
  }
}
